export enum ContactFormType {
    homePage = 0,
    pricing = 1
}